import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { alpha, Box, Menu, MenuItem, Stack, Typography } from '@mui/material';

import profilePic from '../../../../assets/img/user_profile.svg';
import { useGetUserInfo, useLogin } from '@/features/account';
import palette from '@/theme/palette.ts';

export const AccountInfoUtil = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const { logout } = useLogin();
  const { data: user } = useGetUserInfo();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!anchorEl) setAnchorEl(event.currentTarget);
    else setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await logout();
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      onClick={handleClick}
      sx={{
        width: '100%',
        maxWidth: '200px',
        cursor: 'pointer',
        borderRadius: '6px',
        '&:hover': { backgroundColor: alpha(palette.background.secondary, 0.3) },
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{ gap: '10px' }}
        id="basic-button"
      >
        <img src={profilePic} width={55} height={55} />
        <Stack direction="column" alignItems="flex-start" justifyContent="center">
          <Typography variant="body1" sx={{ color: palette.text.primary }}>
            {user?.username || ''}
          </Typography>
          <Typography variant="caption" sx={{ color: palette.text.primary }}>
            Admin
          </Typography>
        </Stack>
      </Stack>

      <Box sx={{ marginRight: '10px', marginTop: '5px' }}>
        <KeyboardArrowDownIcon sx={{ color: palette.arrow.default }} />
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableAutoFocusItem
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '200px',
            borderRadius: '6px',
            marginTop: '10px',
          },
        }}
      >
        <MenuItem onClick={handleLogout}>Odhlásit se</MenuItem>
      </Menu>
    </Stack>
  );
};
